import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProformaIssueFormsDirectRoute: InvariantJiraRoute = {
	name: 'classic-business-proforma-issue-forms-direct',
	path: '/jira/core/projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?',
	exact: true,
};
